import { deleteAccessTokenCookie } from '@/lib/auth';
import { queryClient } from '@/main';

/** Thrown by redirectToSignin so React Query treats the 401 as terminal.
 * The global retry predicate refuses retries for it (#4897). */
export class UnauthorizedError extends Error {
  constructor() {
    super('Unauthorized — session expired, redirecting to signin');
    this.name = 'UnauthorizedError';
  }
}

// One-shot latch: N concurrent 401s must trigger exactly one cleanup +
// navigation, not N cache wipes racing in-flight queries (#4897).
let redirecting = false;

/**
 * Performs authentication cleanup and redirects to signin page.
 * Used when API calls detect invalid/expired tokens.
 *
 * Note: this runs inside queryFn, where a thrown TanStack `redirect()` is NOT
 * honored (that only works in loaders/beforeLoad) — navigation uses a hard
 * location change, which also resets all in-memory state.
 */
export function redirectToSignin(): never {
  if (!redirecting) {
    redirecting = true;
    try {
      deleteAccessTokenCookie();
      queryClient.clear();
    } catch (error) {
      console.error('  ** Error during auth cleanup:', error);
    }
    window.location.assign('/signin');
  }
  throw new UnauthorizedError();
}
